import styled from 'styled-components';
import { getBaseTheme } from '@Themes';

const { spaces, texts } = getBaseTheme();

export const ClauseTextWrapper = styled.div`
    margin: ${spaces.default.xs} 0;
    line-height: ${texts.sizes.xs.lineHeight};
    .divider {
        margin-top: ${spaces.default.xs};
    }
`;
